const services = (dispatch, actions) => ({
  modalToggle: (payload) => {
    dispatch(actions.modalToggle(payload));
  }
});

export default services;
